module.exports = __webpack_public_path__ + "static/media/chart-12k-v2.9d06a6d6.svg";